export default __webpack_public_path__ + "static/404-Error-Page-MB_03-48a2445d8b68e9c703178b2e2a97167b.jpg";